import * as React from "react"

interface ParallaxIProps {
  children: any;
  img: string;
}

export const Parallax : React.FC<ParallaxIProps> = ({ children, img }) => <div className="bg-dark" style={{ background: `center center /cover no-repeat fixed url(${img})`, backgroundSize: "cover" }}>{children}</div>
